import React from "react";

const StoreIcon: React.FC<React.SVGProps<SVGSVGElement>> = (props) => (
  <svg
    width="30"
    height="30"
    viewBox="0 0 30 30"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    {...props}
  >
    <path
      d="M24.0511 27.0683H5.94899L2.18555 10.708H27.8146L24.0511 27.0683Z"
      stroke="currentColor"
      strokeWidth="2"
      strokeMiterlimit="10"
    />
    <path
      d="M20.9274 11.118V7.80124C20.8419 6.29929 20.1792 4.88667 19.0752 3.85329C17.9712 2.81991 16.5097 2.24414 14.9905 2.24414C13.4714 2.24414 12.0098 2.81991 10.9058 3.85329C9.80185 4.88667 9.13914 6.29929 9.05371 7.80124V11.118"
      stroke="currentColor"
      strokeWidth="2"
      strokeMiterlimit="10"
    />
    <path
      d="M7.75537 16.4473C7.75537 16.4473 8.30107 25.9317 13.6828 21.2547C19.0645 16.5777 21.078 14.1926 23.0914 17.323"
      stroke="currentColor"
      strokeWidth="2"
      strokeMiterlimit="10"
    />
  </svg>
);

export default StoreIcon;
